import { put, takeEvery, select } from 'redux-saga/effects'
import { Game, Api, Auth } from '../../Core'

import * as actions from './ranking.actions'
import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'

import Feed from './Feed'
import Post from './Feed/Post'
import RankingButton from './RankingButton'
import RankingScreen from './RankingScreen'
import FederationRanking from './FederationRanking'
import ChatPopup from './ChatPopup'

function* init() {
  yield loadComponents()
}

/**
 *  Load ranking components
 */
export function* loadComponents() {
  const components = {
    Feed,
    Post,
    RankingButton,
    RankingScreen,
    FederationRanking,
    ChatPopup,
  }

  yield put(Game.actions.registerComponents(components))
}

export function* sendMessage(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = { ...action.data, groupId: userInfo.licenseData.groupId }

  try {
    // payload.target.id = userInfo.licenseData.id
    yield Api.post(`/activities/chatMessage`, {}, payload)
    yield put(actions.sendMessageOk())
    yield put(audioActions.playHowlAudio('click'))
    // yield put(Game.actions.removeScreen('chat_screen'))
  } catch (e) {
    console.log(e)
    yield put(actions.sendMessageError(e))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }
}

/**
 *  Documents sagas entrypoint
 */
export function* sagas() {
  yield init()
  yield takeEvery(actions.SEND_MESSAGE, sendMessage)
}
